import { clsx } from "clsx";
import { PropsWithChildren } from "react";

import { UserErrorLevel } from "@smart/itops-utils-basic";

import { Icon, IconName } from "./icon";

const getLevelColor = (level?: UserErrorLevel): string => {
  switch (level) {
    case "SUCCESS":
      return "text-green-600";
    case "WARN":
      return "text-red-600";
    case "INFO":
      return "text-blue-500";
    case "DEFAULT":
      return "text-slate-600";
    default:
      return "text-slate-500";
  }
};

type OverlayProps = PropsWithChildren<{
  icon?: IconName;
  image?: string;
  heading?: string;
  subHeading?: string;
  title?: string;
  level?: UserErrorLevel;
}>;

export const Overlay = ({
  heading,
  subHeading,
  title,
  icon,
  image,
  level,
  children,
}: OverlayProps) => (
  <div
    className={clsx(
      "absolute inset-0 bg-white/95 flex flex-col items-center justify-center",
      getLevelColor(level),
    )}
    title={title}
  >
    <div className="p-8 max-w-[50rem] w-full text-center">
      {icon && <Icon name={icon} className="w-16 h-16" />}
      {image && (
        <img src={image} alt={title} className="block mx-auto my-8 w-24" />
      )}
      {heading && (
        <h1
          className="!text-4xl font-bold my-4"
          style={{ fontSize: "3.75rem" }}
        >
          {heading}
        </h1>
      )}
      {subHeading && (
        <p className="text-xl font-medium leading-relaxed my-4">{subHeading}</p>
      )}
      {children}
    </div>
  </div>
);

export type { OverlayProps };
